import {Component} from '@angular/core';
import { MatCard, MatCardTitle } from '@angular/material/card';

@Component({
    selector: 'app-cgu',
    templateUrl: './cgu.component.html',
    styleUrls: ['./cgu.component.css'],
    imports: [MatCard, MatCardTitle]
})
export class CguComponent {

}
